function getViewportElement(useHtml = false): Element {
  const customViewport = document.querySelector('.osw-viewport');
  const defViewport = useHtml ? document.documentElement : document.body;

  return customViewport || defViewport;
}

export default getViewportElement;
